import PaymentLinkPage from "../components/payment-link";

export default PaymentLinkPage;
